var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08745 3.80989L1.52852 0.250952C1.36122 0.0836523 1.14829 1.71003e-06 0.889732 1.75446e-06C0.631177 1.79889e-06 0.41825 0.0836524 0.250949 0.250953C0.0836492 0.418253 -9.55132e-07 0.631181 -9.09134e-07 0.889736C-8.63137e-07 1.14829 0.0836493 1.36122 0.25095 1.52852L4.44867 5.72624C4.63118 5.90874 4.8441 6 5.08745 6C5.3308 6 5.54372 5.90874 5.72623 5.72623L9.92395 1.52852C10.0912 1.36122 10.1749 1.14829 10.1749 0.889734C10.1749 0.631179 10.0912 0.418251 9.92395 0.250951C9.75665 0.0836508 9.54372 2.67355e-07 9.28517 3.11785e-07C9.02661 3.56215e-07 8.81368 0.083651 8.64638 0.250951L5.08745 3.80989Z",
    fill: "#1E1531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard-arrow-down.218143149d04476138dd939eb3d17648.svg";
export { ForwardRef as ReactComponent };